import React, { Component } from 'react'
import { CabinetSelect } from '../../components/Cabinet'
import { pxToRem } from '../../utils'
import styled from 'styled-components'
import { components } from 'react-select'

const Wrapper = styled.div`
  margin-bottom: ${pxToRem(13)};
  padding-bottom: ${pxToRem(20)};
  border-bottom: 1px solid #dadfe2;
`

const ResultProvider = styled.div`
  flex: 1;
  order: 1;
  font-size: ${pxToRem(11)};
  color: #858585;
`
const ResultName = styled.div`
  font-family: 'Open Sans', sans-serif;
  texttransform: 'uppercase';
  font-size: ${pxToRem(14)};
  color: #858585;
`

const Option = props => {
  return (
    <components.Option {...props}>
      <ResultName>{props.data.label}</ResultName>
      <ResultProvider>{props.data.provider}</ResultProvider>
    </components.Option>
  )
}

class CabinetSearch extends Component {
  render() {
    const { value, onInputChange, onChange, loadOptions, ...rest } = this.props
    return (
      <Wrapper>
        <CabinetSelect
          {...rest}
          value={value}
          onInputChange={onInputChange}
          onChange={onChange}
          loadOptions={loadOptions}
          components={{ Option }}
        />
      </Wrapper>
    )
  }
}

export default CabinetSearch



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/CabinetSearch.js